<template>
  <div class="listing-page">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />

    <section class="section car-listing pt-0">
      <div class="container">
        <div class="row">
          <listing-sidebar></listing-sidebar>

          <div class="col-lg-9">
            <!-- loading -->
            <div
              v-if="carsStore.isLoading"
              class="d-flex justify-content-center align-items-center"
              style="min-height: 60vh; width: 100%;"
            >
              <a-spin size="large" tip="جاري التحميل..." />
            </div>
            <!-- No data-->
            <div 
              v-else-if="!carsStore.cars.length" 
              class="w-100 text-center mt-10"
              style="margin-top: 60px !important;"
            >
              <p class="fs-4 fw-bold text-dark">🚗 لا توجد سيارات متاحة حاليا</p>
            </div>


            <!-- Cars Grid -->
            <div class="row" v-else>
              <div
                class="col-lg-4 col-md-6 col-12"
                v-for="item in paginatedCars"
                :key="item.id"
                data-aos="fade-down"
              >
                <div class="listing-item">
                  <div class="listing-img">
                    <router-link
                      to="/listing/listing-details"
                      v-if="item.images && item.images.length === 1"
                    >
                      <img
                        :src="item.images[0].image"
                        class="img-fluid"
                        :alt="item.title"
                      />
                    </router-link>

                    <!-- Slider -->
                    <div class="img-slider owl-carousel" v-else>
                      <Carousel
                        :wrap-around="true"
                        :settings="settings"
                        :breakpoints="breakpoints"
                      >
                        <Slide
                          v-for="slideItem in item.images"
                          :key="slideItem.id"
                        >
                          <div class="slide-images">
                            <router-link to="/listing/listing-details">
                              <img
                                :src="slideItem.image"
                                class="img-fluid"
                                :alt="item.title"
                              />
                            </router-link>
                          </div>
                        </Slide>
                        <template #addons>
                          <Pagination />
                          <Navigation />
                        </template>
                      </Carousel>
                    </div>
                  </div>

                  <div class="listing-content">
                    <h3 class="listing-title">
                      <router-link to="/listing/listing-details">
                        {{ item.title }}
                      </router-link>
                    </h3>
                    <p>{{ item.price }} ل.س</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pagination Controls -->
            <div class="d-flex justify-content-center mt-4" v-if="totalPages > 1">
              <button
                class="btn btn-outline-primary mx-2"
                :disabled="currentPage === 1"
                @click="prevPage"
              >
                السابق
              </button>

              <span class="align-self-center">صفحة {{ currentPage }} من {{ totalPages }}</span>

              <button
                class="btn btn-outline-primary mx-2"
                :disabled="currentPage === totalPages"
                @click="nextPage"
              >
                التالي
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <layout-footer></layout-footer>
  </div>
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { useCarsStore } from "@/stores/cars-store";

export default {
  setup() {
    const carsStore = useCarsStore();
    carsStore.fetchCars();

    return { carsStore };
  },
  data() {
    return {
      title: "Car Listings",
      text: "Listings",
      text1: "Car Listings",
      settings: { itemsToShow: 1, snapAlign: "center" },
      breakpoints: {
        575: { itemsToShow: 1, snapAlign: "center" },
        767: { itemsToShow: 1, snapAlign: "center" },
        991: { itemsToShow: 1, snapAlign: "center" },
        1024: { itemsToShow: 1, snapAlign: "start" },
      },
      // Pagination
      currentPage: 1,
      itemsPerPage: 6,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.carsStore.cars.length / this.itemsPerPage);
    },
    paginatedCars() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.carsStore.cars.slice(start, end);
    },
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  components: { Carousel, Slide, Pagination, Navigation },
};
</script>

<style scoped>
.listing-img img {
  width: 100%;
  height: 220px;   
  object-fit: cover;
  border-radius: 8px; 
}

</style>
